import { BsFillPatchCheckFill } from "react-icons/bs";

const Sdata=[
    {
          title:["Development"],
        title1:[<BsFillPatchCheckFill/>,"CSS"],
        title2:[<BsFillPatchCheckFill/>,"ReactJS"],
        title3:[<BsFillPatchCheckFill/>,"MongoDB"],
        title4:[<BsFillPatchCheckFill/>,"ExpressJS"],
        title5: [<BsFillPatchCheckFill />, "NodeJS"],
        title6:[<BsFillPatchCheckFill/>,"MaterialUI"]
    }
    ,
    {
        title:["Coding"],
        title1:[<BsFillPatchCheckFill/>,"C"],
        title2:[<BsFillPatchCheckFill/>,"C++"],
        title3:[<BsFillPatchCheckFill/>,"Data Structure"],
    }
]
export default Sdata;
